import { createAction, props } from '@ngrx/store';
import type { NotificationItem } from '../../services/notifications.service';
import type { NotificationsFilter } from './notifications.types';

export const loadNotificationsPage = createAction(
  '[Notifications] Load Page',
  props<{
    filter: NotificationsFilter;
    page: number;
    pageSize: number;
    showLoading: boolean;
  }>()
);

export const loadNotificationsPageSuccess = createAction(
  '[Notifications] Load Page Success',
  props<{ items: NotificationItem[]; totalItems: number }>()
);

export const loadNotificationsPageFailure = createAction(
  '[Notifications] Load Page Failure',
  props<{ error: string }>()
);

export const markNotificationAsRead = createAction(
  '[Notifications] Mark As Read',
  props<{ id: string }>()
);

export const markNotificationAsReadSuccess = createAction(
  '[Notifications] Mark As Read Success',
  props<{ id: string }>()
);

export const markNotificationAsReadFailure = createAction(
  '[Notifications] Mark As Read Failure',
  props<{ id: string; error: string }>()
);

export const startUnreadCountPolling = createAction(
  '[Notifications] Start Unread Count Polling',
  props<{ tenantContextKey: string }>()
);

export const setUnreadCount = createAction(
  '[Notifications] Set Unread Count',
  props<{ unreadCount: number }>()
);
